import { useRequiredContext } from "@redotech/react-util/context";
import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { OnboardingProps } from "../common";

export const ReclaimAnnouncementOnboarding = memo(
  function ReclaimAnnouncementOnboarding({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    const team = useRequiredContext(TeamContext);
    const navigate = useNavigate();

    const handleAction = () => {
      navigate(`/stores/${team._id}/finance/disputes`);
      handleComplete();
    };

    return (
      <RedoFeatureNotificationCard
        actionText="Check it out"
        description="Discover how AI-powered chargeback disputes can help you recover lost revenue with Reclaim"
        image="https://assets.getredo.com/reclaim-announcement.png"
        onAction={handleAction}
        onDismiss={handleDismiss}
        title="Start winning chargebacks"
      />
    );
  },
);
